<script>
    import { onMount } from "svelte";
    import { Input, Spinner } from "sveltestrap";
    import AppFilter from "./AppFilter.svelte";
    import AppIconDraw from "./AppIconDraw.svelte";
    import Collapsed from "./Collapsed.svelte";
    import AppFilterStyleBackground from "./draw/AppFilterStyleBackground.svelte";
    import {
      filterNamesFilter,
      filterNamesFilterColor
    } from "./utils/filters.js";
    import { _log } from "./utils/logger";
    import { ratioH } from "./utils/util";
    export let images;
    export let _filters = {};
    let imgRef2;
    let img;
    let filterApplyCount = 0;
    let radioBG = ["both", "background", "people"];
    let radioBGGroup = "radioBG";
    let url;
    let worker;
    let isOriginalImage = true;
    const WORKER_URL = "js/filter.worker.js";
    let w, h;
    let isFilterLoading = false;

    function getCurrentImage(url, w, h) {
        return new Promise((res) => {
            const backgroundImage = new Image();
            backgroundImage.width = w;
            backgroundImage.height = h;
            backgroundImage.onload = () => {
                res(img);
            };
            backgroundImage.src = url;
        });
    }

    // async function mask() {
    //     const h = img.height;
    //     const w = img.width;
    //     const backgroundImage = await getCurrentImage(imgRef2.toDataURL(), w, h)
    //     const ctx = imgRef2.getContext("2d")
    //     const width = w
    //     const height = h
    //     imgRef2.width = width
    //     imgRef2.height = height
    //     const segmentation = await net.segmentPerson(imgRef, {
    //         flipHorizontal: false, // Whether to flip the input video horizontally
    //         internalResolution: 'high', // The resolution for internal processing (options: 'low', 'medium', 'high')
    //         segmentationThreshold: 0.7, // Segmentation confidence threshold (0.0 - 1.0)
    //         maxDetections: 10, // Maximum number of detections to return
    //         scoreThreshold: 0.2, // Confidence score threshold for detections (0.0 - 1.0)
    //         nmsRadius: 20, // Non-Maximum Suppression (NMS) radius for de-duplication
    //         minKeypointScore: 0.3, // Minimum keypoint detection score (0.0 - 1.0)
    //         refineSteps: 10, // Number of refinement steps for segmentation
    //     });

    //     // 2. Creating a Background Mask
    //     const background = { r: 0, g: 0, b: 0, a: 0 };
    //     const mask = bodyPix.toMask(segmentation, background, { r: 0, g: 0, b: 0, a: 255 });

    //     if (mask) {
    //         ctx.putImageData(mask, 0, 0);
    //         ctx.globalCompositeOperation = 'source-in';
    //         ctx.drawImage(backgroundImage, 0, 0, width, height);

    //         // Draw the mask (segmentation)
    //         ctx.globalCompositeOperation = 'destination-over';
    //         ctx.drawImage(imgRef, 0, 0, width, height);
    //         ctx.globalCompositeOperation = 'source-over';
    //     }
    // }

    function initWorker() {
        if (worker) {
            worker.terminate();
        }
        worker = new Worker(WORKER_URL);
        // worker.postMessage({ type: "start", data: { w, h, url } });
        window["filter_worker"] = worker;
        worker.addEventListener("message", (e) => {
            if (e.data.type === "bitmap") {
                isFilterLoading = false;
                imgRef2
                    .getContext("2d")
                    .drawImage(
                        e.data.data.bitmap,
                        0,
                        0,
                        imgRef2.width,
                        imgRef2.height,
                    );
                _log("e.data", e.data.data.bitmap);
            }
        });
    }

    onMount(async () => {
        //initWorker();

        // net = await bodyPix.load({
        //     architecture: 'MobileNetV1',
        //     outputStride: 16, // Output stride (16 or 32). 16 is faster, 32 is more accurate.
        //     multiplier: 0.75, // The model's depth multiplier. Options: 0.50, 0.75, or 1.0.
        //     quantBytes: 2, // The number of bytes to use for quantization (4 or 2).
        // });

        if (images && images.length > 0) {
            url = images[0].url;
        } else {
            url = "/test.jpg";
        }
        setImage(url);
        if (images && images.length > 1) {
            currentImageIndex = 1;
        }
        return () => {
            window["app_filter"] = {};
        };
    });

    const onChangeFilter = ({ detail: { name, value } }) => {
        _log("onClickReset", name, value);
        // const _filters = { ..._filters };
        _filters[name] = Number(value);

        applyFilter(_filters);
    };

    const setImage = (url, index = 0) => {
        return new Promise((res) => {
            img = new Image();
            img.onload = () => {
                const canvas2 = imgRef2;
                if (canvas2) {
                    //const w = window.innerWidth   - 240;
                    //  let w = img.width
                    //  let h = img.height
                    w = img.width;
                    if (img.width > 1400) {
                        w = 1400;
                    }
                    if (w > window.innerWidth - 240) {
                        w -= 240;
                    }
                    h = ratioH(img.height, img.width, w);

                    canvas2.width = w;
                    canvas2.height = h;
                    _log("WH", w, h);
                    canvas2.getContext("2d").drawImage(img, 0, 0, w, h);
                    res(true);
                }
            };
            if (images.length > 0) {
                img.src = images[index].url;
            } else {
                img.src = url;
            }
        });
    };

    const applyFilter = (filters) => {
        if (!filters) return;
        isFilterLoading = true;
        initWorker();
        worker.postMessage({ type: "filter", data: { filters, w, h, url } });
    };
    function onPatternClick(e) {
        const url = e.detail.url;
        _log("onPatternClick", url);
        _filters["background"] = url;
        // worker.postMessage({ type: "reset_style", data: {} });
        applyFilter(_filters);
    }

    function onChangeBGGroup(e) {
        const val = e.target.value;
        _log("onChangeBGGroup", val);
        if (val === "both") {
            _filters["style_bg"] = null;
        } else {
            _filters["style_bg"] = val;
        }
        applyFilter(_filters);
        //radioBGGroup = val
    }
    let currentImageIndex = 0;
    async function nextImageHandler() {
        try {
            if (!images || images.length < 1) return;
            if (currentImageIndex >= images.length) {
                currentImageIndex = 0;
            }
            url = images[currentImageIndex].url;
            await setImage(url, currentImageIndex);
            currentImageIndex += 1;
            applyFilter(_filters);
        } catch {}
    }
</script>

<div class="filters-container flex">
    <div class="filters-container-items">
        <div>
            {#each filterNamesFilter as filter}
                <AppFilter
                    {_filters}
                    {filter}
                    on:change={onChangeFilter}
                    name={filter}
                />
            {/each}
        </div>
        <Collapsed name="color" />
        <div class="flex collapsable">
            {#each filterNamesFilterColor as filter}
                <AppFilter
                    {_filters}
                    {filter}
                    on:change={onChangeFilter}
                    name={filter}
                />
            {/each}
        </div>

    </div>
    <div class="img-filter-preview-wrapper">
        <div class="flex radio-filters">
            <div
                class="flex"
                style={`visibility: ${isFilterLoading ? "visible" : "hidden"}`}
            >
                <Spinner type="grow" color="danger" size="sm" />
            </div>
            {#each radioBG as value}
                <Input
                    type="radio"
                    on:change={onChangeBGGroup}
                    bind:group={radioBGGroup}
                    label={value}
                    {value}
                />
            {/each}
            <AppFilterStyleBackground on:onPatternClick={onPatternClick} />
            {#if images && images.length > 1}
                <div class="next-image-icon" on:click={nextImageHandler}>
                    <AppIconDraw name="undo" />
                </div>
            {/if}
        </div>
        <canvas bind:this={imgRef2} class='canvas_fit'/>
    </div>
</div>
